<div class="bg-m1 flex h-full cursor-default flex-col">
  <div
    class="flex h-2 flex-1 flex-row items-center justify-center overflow-y-auto"
  >
    <div class="flex w-96 flex-col items-center space-y-6">
      <div>
        <m-email-ring></m-email-ring>
      </div>

      <div class="text-s2 select-none text-2xl font-semibold">{{
        pageTitle
      }}</div>

      <div class="text-s1 text-center text-base">
        <div> An email has been sent to your email address, </div>
        <div> {{ email }}. </div>
        <div> Follow the instructions to set a new password. </div>
      </div>

      <button
        data-cy="passwordResetSentDoneButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        (click)="done()"
        >Done</button
      >
    </div>
  </div>
</div>
